import React, { useState, useEffect } from "react";
import Joyride, { STATUS } from "react-joyride";
import { Link } from "react-router-dom";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
} from "mdb-react-ui-kit";
const ServicesTour = () => {
  const [stepIndex, setStepIndex] = useState(0);
  const [run, setRun] = useState(false);

  useEffect(() => {
    setRun(true);
  }, []);

  const steps = [
    {
      target: "#card-listing",
      content: "🚀 Click this card to speed up listings",
      disableBeacon: true,
      hideFooter: true,
      disableOverlayClose: true,
    },
    {
      target: "#card-warehouse",
      content: "📦 Now organize your inventory",
      disableBeacon: true,
      hideFooter: true,
      disableOverlayClose: true,
    },
    {
      target: "#card-sync",
      content: "🔄 Sync online & in-store sales",
      disableBeacon: true,
      hideFooter: true,
      disableOverlayClose: true,
    },
  ];

  const handleJoyrideCallback = (data) => {
    const { status } = data;

    if (status === STATUS.FINISHED) {
      setRun(false);
    }
  };

  /* 🔥 THIS is how steps move */
  const moveNext = () => {
    setStepIndex((prev) => prev + 1);
  };

  return (
    <>
      <Joyride
        steps={steps}
        run={run}
        stepIndex={stepIndex}
        callback={handleJoyrideCallback}
        continuous={false}
        showSkipButton={false}
        hideCloseButton={true}
        disableCloseOnEsc={true}
        spotlightClicks={true}
        styles={{
          options: {
            overlayColor: "rgba(0,0,0,0.85)",
            zIndex: 10000,
          },
        }}
      />
      <MDBContainer className="py-5">
        {/* Heading */}
        <div className="text-center mb-5">
          <h3 className="fw-bold">What’s slowing you down right now?</h3>
          <p className="text-muted">
            Tell us where you’re stuck; we’ll tailor ThriftOps to help you move
            faster.
          </p>
        </div>
        <MDBRow className="g-4">
          {/* CARD 1 */}
          <MDBCol md="4">
            <MDBCard
              id="card-listing"
              className="h-100 shadow"
              onClick={() => stepIndex === 0 && moveNext()}
              // style={{
              //   pointerEvents: stepIndex === 0 ? "auto" : "none",
              // }}
            >
              <MDBCardBody>
                <MDBCardTitle>Listing</MDBCardTitle>
                <h6 className="text-muted">Listing items takes too long</h6>
                <MDBCardText>
                  Create listings from a single photo with auto descriptions,
                  pricing, and cross-posting—no manual work.
                </MDBCardText>
                <MDBBtn tag={Link} to="/products/add" color="danger">
                  Speed up my listings →
                </MDBBtn>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>

          {/* CARD 2 */}
          <MDBCol md="4">
            <MDBCard
              id="card-warehouse"
              className="h-100 shadow"
              onClick={() => stepIndex === 1 && moveNext()}
            >
              <MDBCardBody>
                <MDBCardTitle>Warehousing</MDBCardTitle>
                <h6 className="text-muted">
                  Managing 1/1 inventory is chaotic
                </h6>
                <MDBCardText>
                  Track every unique item with barcodes, locations, and
                  real-time visibility—built for thrift, not bulk SKUs.
                </MDBCardText>
                <MDBBtn color="danger">Organize my inventory →</MDBBtn>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>

          {/* CARD 3 */}
          <MDBCol md="4">
            <MDBCard
              id="card-sync"
              className="h-100 shadow"
              onClick={() => stepIndex === 2 && moveNext()}
            >
              <MDBCardBody>
                <MDBCardTitle>Online + In-Store Sync</MDBCardTitle>
                <h6 className="text-muted">
                  Online and in-store inventory doesn’t stay in sync
                </h6>
                <MDBCardText>
                  Sell everywhere without overselling; keep your physical floor
                  and online channels perfectly aligned.
                </MDBCardText>
                <MDBBtn color="danger">Sync my sales channels →</MDBBtn>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
        {/* Bottom line */}
        <div className="text-center mt-5">
          <a
            href="https://www.thriftops.com/"
            className="fw-semibold text-decoration-none"
          >
            Need everything working together? Explore ThriftOps as a complete
            system →
          </a>
        </div>
      </MDBContainer>
    </>
  );
};

export default ServicesTour;
